<template>
  <div id="app">
    <v-app>
      <nav-bar :tabs="tabs" :app_icon="app_icon" v-show="show_header" data-html2canvas-ignore />
      <PageHeader v-if="show_header" data-html2canvas-ignore />
      <v-main :class="{ 'pl-1': !show_header }">
        <v-container fill-height :class="`backgroundLight ${show_header ? 'main-container' : ''}`" fluid>
          <error />
          <v-row no-gutters>
            <v-col cols="12" :class="$store.state.loader ? 'main-con hide-overflow' : 'main-con'">
              <div :class="`${show_header ? 'content-con' : 'report-con'}`">
                <router-view />
              </div>
              <SnackBarVT></SnackBarVT>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import Error from "./components/Error";
import PageHeader from "./components/PageHeader";
import debounce from "lodash/debounce";
import SnackBarVT from "./components/SnackBarVT";
import { axios_get } from "./services/vt_service";
import { user, settings } from "./services/common";
import { fn } from "./services/utility";
import { content } from "../config/config.js";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "app",
  components: {
    NavBar,
    Error,
    PageHeader,
    SnackBarVT,
  },
  data: () => ({
    customer_sections: null,
    duration: 4000,
    data_call_interval: null,
  }),
  watch: {
    $route: function (newVal) {
      if (this.customer_sections && this.$store.state.sections) {
        if (newVal.path == "/") {
          this.redirect_user(newVal.path);
        }
      }
    },
  },
  created() {
    if (process.env["VUE_APP_TITLE"]) document.title = process.env["VUE_APP_TITLE"];
    this.loadUserback();
  },
  updated: debounce(function () {
    this.$nextTick(() => {
      this.triggerWindowResize();
    });
  }, 500),
  mounted() {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = process.env["VUE_APP_FAVICON"] ? `/assets/images/${process.env["VUE_APP_FAVICON"]}` : "";
  },
  methods: {
    triggerWindowResize() {
      var resizeEvent = window.document.createEvent("UIEvents");
      resizeEvent.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    },
    loadUserback() {
      setTimeout(() => {
        window.Userback = window.Userback || {};
        window.Userback.access_token = "33220|61617|LhAWOQcImz4irvtK9nm86igFy";
        window.Userback.widget_settings = {
          logo: `/assets/images/${this.app_icon}`,
        };
        (function (d) {
          var s = d.createElement("script");
          s.async = true;
          s.src = "https://static.userback.io/widget/v1.js";
          (d.head || d.body).appendChild(s);
        })(document);
      }, 1000);
    },
    async get_tabs() {
      const accessToken = this.$auth && this.$auth.isAuthenticated ? await this.$auth.getTokenSilently() : "";
      const tenant = (this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      if (accessToken && tenant) {
        const response = await axios_get(settings.get_tenant_config);
        fn.update_tenant(response);
        if (response.type == "tracking")
          this.data_call_interval = setInterval(() => {
            fn.tracking_data_update();
          }, 300000);
        this.customer_sections = response.tabs;
        let sections = [];
        let labels = [];
        let ids = [];
        this.customer_sections.forEach((elem) => {
          if (this.$config.tabs[elem.id]) {
            let route = this.$config.tabs[elem.id].route;
            sections.push(route);
            labels.push(elem.label);
            ids.push(elem.id);
          }
        });
        this.$store.commit("set_sections", [sections, labels, ids]);
        this.get_user_config();
      }
    },
    async get_user_config() {
      let response = (await axios_get(user.get_user_config)) || {};
      // If temperature_metric field not present assign it.
      if (response) {
        if (
          !("temperature_metric" in response) ||
          response.temperature_metric == null ||
          response.temperature_metric === ""
        ) {
          response.temperature_metric = this.$options.filters.assignTemperatureMetric();
        }
      }
      if (response && response) this.$store.commit("update_config", response);
      this.redirect_user(window.location.pathname);
    },
    redirect_user(path) {
      if (path == "/" && this.$store.state.user_config && this.$store.state.user_config.default_section) {
        this.$router.push(this.$config.tabs[this.$store.state.user_config.default_section].route);
        this.$store.commit("update_page_title", this.section_obj[this.$store.state.user_config.default_section]);
      } else if (path == "/" && (!this.$store.state.user_config || !this.$store.state.user_config.default_section)) {
        this.$router.push(this.$config.tabs[this.customer_sections[0].id].route);
        this.$store.commit("update_page_title", this.section_obj[this.customer_sections[0].id]);
      }
    },
  },
  computed: {
    page_content: function () {
      return content || null;
    },
    show_header: function () {
      return this.page_content ? this.page_content.no_header_route_names.indexOf(this.$route.name) == -1 : false;
    },
    section_obj: function () {
      let section_obj = {};
      this.customer_sections &&
        this.customer_sections.map((elem) => {
          section_obj[elem.id] = elem.label;
        });
      return section_obj;
    },
    tabs: function () {
      this.$auth.user && !this.customer_sections && this.get_tabs();
      this.customer_sections &&
        this.customer_sections.map((elem) => {
          this.section_obj[elem.id] = elem.label;
        });
      let tabs = [];
      if (this.$store.state.user_config && this.$store.state.user_config.sections_order) {
        this.$store.state.user_config &&
          this.$store.state.user_config.sections_order &&
          this.$store.state.user_config.sections_order.map((elem) => {
            if (this.section_obj[elem])
              tabs.push({
                ...this.$config.tabs[elem],
                label: this.section_obj[elem],
              });
          });
      } else {
        this.customer_sections &&
          this.customer_sections.map((elem) => {
            tabs.push({ ...elem, ...this.$config.tabs[elem.id] });
          });
      }
      return tabs;
    },
    app_icon: function () {
      return process.env["VUE_APP_ICON"];
    },
  },
  beforeDestroy() {
    // Clear interval when component is destroyed
    clearInterval(this.data_call_interval);
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/sass/styles.scss";

* {
  margin: 0;
  padding: 0;
  font-family: Trade Gothic Regular;
}

.v-application {
  font-family: Trade Gothic Regular !important;

  ::v-deep .v-navigation-drawer {
    .v-item-group .v-list-item:first-child {
      padding: 0 0.4em;
      margin: 0;

      .v-responsive {
        max-width: none;

        .v-image__image {
          -webkit-transition:
            max-width 5s linear 5s,
            height 5s linear 5s;
          background-position: left !important;
        }
      }
    }

    .v-list-item {
      margin: 0 0.3em;
      padding: 0 0.75em;
      border-radius: 0.25em;
    }

    .v-list-item:hover {
      text-decoration: none;
      margin: 0 0.3em;
    }
  }

  ::v-deep .v-navigation-drawer--mini-variant .v-image__image {
    width: 40px !important;
  }

  ::v-deep label.v-label {
    margin-bottom: 0;
    margin-right: 0.5rem;
    height: 22px;
  }

  .slide-enter-from {
    transform: translateX(100%);
  }

  .slide-enter-to {
    transform: translateX(0);
  }

  .slide-leave-from {
    transform: translateX(0);
  }

  .slide-leave-to {
    transform: translateX(-100%);
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 1s ease-in-out;
  }

  ::v-deep .title {
    font-family:
      Trade Gothic Bold,
      sans-serif !important;
  }

  ::v-deep .subtitle-2 {
    font-family:
      Trade Gothic Regular,
      sans-serif !important;
  }

  ::v-deep .caption {
    font-family:
      Trade Gothic Regular,
      sans-serif !important;
    line-height: 1rem;
  }

  ::v-deep .bold {
    font-family:
      Trade Gothic Bold,
      sans-serif !important;
  }

  ::v-deep .font-black {
    font-family:
      Trade Gothic Bold,
      sans-serif !important;
  }

  ::v-deep .v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    box-shadow: none;

    .v-input__append-inner {
      margin-top: 0.3em;

      .v-icon {
        color: var(--v-primaryOutline-base);
      }
    }
  }

  ::v-deep .v-text-field .v-input__control .v-input__slot .v-select__slot {
    height: 32px !important;
  }

  ::v-deep .v-tooltip__content.tool-tip {
    background-color: var(--v-backgroundWhite-base);
    color: var(--v-primary-base);
    padding: 0;
    font-size: 0.75em;
  }

  .container-width {
    min-width: 100%;
  }

  .main-container {
    min-height: 100vh;

    .content-con {
      min-height: calc(100vh - 10px);
      max-width: calc(100vw - 75px);
    }

    @media only screen and (min-width: 1600px) {
      .content-con {
        max-width: calc(100vw - 256px);
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      // margin: auto;

      .report-con {
        overflow-y: auto;
        height: 100%;
      }
    }

    .main-con.hide-overflow {
      overflow-y: hidden;
    }

    .layout {
      overflow: auto;
    }
  }
}
</style>
